import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-293b84d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative mx-auto" }
const _hoisted_2 = ["onMouseup"]
const _hoisted_3 = { class: "bg-gray-800 bg-opacity-30 p-4 shadow-lg hover:shadow-2xl h-full w-full rounded-3xl overflow-hidden" }
const _hoisted_4 = { class: "relative flex items-end overflow-hidden h-96 w-full rounded-3xl" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "mt-4 p-2" }
const _hoisted_7 = { class: "text-slate-400 font-bold text-xl text-center" }
const _hoisted_8 = { class: "text-sm text-slate-500 line-clamp-2 mt-2" }
const _hoisted_9 = {
  key: 1,
  class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"relative flex items-end overflow-hidden rounded-xl\" data-v-293b84d8><div class=\"h-72 bg-gray-600 rounded-xl mb-4 w-full\" data-v-293b84d8></div></div><div class=\"mt-1 p-2\" data-v-293b84d8><div class=\"h-4 bg-gray-600 rounded w-3/4 mb-2\" data-v-293b84d8></div><div class=\"h-4 bg-gray-600 rounded w-1/2\" data-v-293b84d8></div></div>", 2)
const _hoisted_12 = [
  _hoisted_10
]
const _hoisted_13 = { key: 2 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-6 h-6",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 19l-7-7 7-7"
  })
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-6 h-6",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5l7 7-7 7"
  })
], -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hidden lg:block pointer-events-none absolute top-0 left-0 w-32 h-full z-10 bg-gradient-to-r from-gray-900 to-transparent" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hidden lg:block pointer-events-none absolute top-0 right-0 w-32 h-full z-10 bg-gradient-to-l from-gray-900 to-transparent" }, null, -1))

import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { Carousel, Slide } from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';
import Api from '@/services/api';

interface Page {
  customUrl: string;
  title: string;
  description: string;
  image: string;
  type: 'game' | 'blog' | 'project';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardCarrossel',
  setup(__props) {

const pages = ref<Page[]>([]);
const carouselRef = ref<any>(null);
const carouselItemsToShow = ref(1);
const isLoading = ref(true);
const isDragging = ref(false);

const router = useRouter();

const gameItems = computed(() => pages.value);

const fetchPages = async () => {
  try {
    const projection = {
      customUrl: 1,
      title: 1,
      description: 1,
      image: 1,
    };
    const response = await Api.getPages({ type: 'game' }, projection);
    pages.value = response.data;
  } catch (error) {
    console.error('Error fetching pages:', error);
  } finally {
    isLoading.value = false;
  }
};

const updateItemsToShow = () => {
  const width = window.innerWidth;
  if (width < 640) {
    carouselItemsToShow.value = 1;
  } else if (width < 1024) {
    carouselItemsToShow.value = 2;
  } else {
    carouselItemsToShow.value = 4;
  }
};

const nextSlide = () => carouselRef.value?.next();
const prevSlide = () => carouselRef.value?.prev();

const handleClick = (url: string) => {
  if (!isDragging.value) {
    router.push(`/pages/${url}`);
  }
  isDragging.value = false;
};

onMounted(() => {
  fetchPages();
  updateItemsToShow();
  window.addEventListener('resize', updateItemsToShow);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateItemsToShow);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (gameItems.value.length > 0)
        ? (_openBlock(), _createBlock(_unref(Carousel), {
            key: 0,
            itemsToShow: carouselItemsToShow.value,
            transition: 500,
            "mouse-drag": true,
            pauseAutoplayOnHover: true,
            "wrap-around": true,
            ref_key: "carouselRef",
            ref: carouselRef,
            onDragstart: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
          }, {
            default: _withCtx(({ currentSlide }) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gameItems.value, (game, index) => {
                return (_openBlock(), _createBlock(_unref(Slide), { key: index }, {
                  default: _withCtx(({ index: slideIndex }) => [
                    _createElementVNode("article", {
                      class: _normalizeClass(["duration-300 transform transition-transform cursor-pointer overflow-hidden rounded-3xl", [
              slideIndex === currentSlide
                ? 'scale-100 z-20'
                : 'scale-95 opacity-80 z-10'
            ]]),
                      onMousedown: _cache[0] || (_cache[0] = ($event: any) => (isDragging.value = false)),
                      onMousemove: _cache[1] || (_cache[1] = ($event: any) => (isDragging.value = true)),
                      onMouseup: ($event: any) => (handleClick(game.customUrl))
                    }, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("img", {
                            src: game.image,
                            alt: "Game Photo",
                            class: "w-full h-full object-cover",
                            loading: "lazy"
                          }, null, 8, _hoisted_5)
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("h2", _hoisted_7, _toDisplayString(game.title), 1),
                          _createElementVNode("p", _hoisted_8, _toDisplayString(game.description), 1)
                        ])
                      ])
                    ], 42, _hoisted_2)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["itemsToShow"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(carouselItemsToShow.value, (n) => {
              return (_openBlock(), _createElementBlock("div", {
                key: n,
                class: "rounded-xl bg-gray-800 bg-opacity-30 animate-pulse p-4 shadow-lg"
              }, _hoisted_12))
            }), 128))
          ])),
      (gameItems.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("button", {
              onClick: prevSlide,
              class: "absolute top-1/2 left-0 transform -translate-y-1/2 bg-gray-900/70 text-white py-4 px-4 rounded-full z-20"
            }, _hoisted_15),
            _createElementVNode("button", {
              onClick: nextSlide,
              class: "absolute top-1/2 right-0 transform -translate-y-1/2 bg-gray-900/70 text-white py-4 px-4 rounded-full z-20"
            }, _hoisted_17)
          ]))
        : _createCommentVNode("", true),
      _hoisted_18,
      _hoisted_19
    ])
  ]))
}
}

})